module.exports = __webpack_public_path__ + "img/signal-stream.ae6aed5b.svg";